import React from "react";


export default function PopupButton(props) {
    return (
        <div className="text-city-white bg-city-green-medium hover:bg-city-green-dark rounded-sm px-2 my-1 py-0.5 cursor-pointer w-fit mx-auto" onClick={() => props.setIsPopupOpen(true)}>
            About
        </div>
    )
}